var SimpleCypher = require('../../../../libs/simple-cypher');


/*
NOTES:
    All functions should take the following function params.
    @param {Array} listings

    They will also always return an Array
    @returns {Array}
*/

var listingFilters = {
    /*
    Removes any listings that are no longer active

    @function removeInactiveListings
    */

    removeInactiveListings: function removeInactiveListings(listings) {
        return listings.filter(function filterListing(listing) {
            return listing.active !== false || (!!listing.status && !!~['fail', 'sold'].indexOf(listing.status.toLowerCase()));
        });
    },


    /*
    Remove listings where the source is first am
    and they do not have a hero image.

    @function filterFirstAMNoHeroImage
    */

    filterFirstAMNoHeorImage: function filterFirstAMNoHeorImage(listings) {
        return listings.filter(function (listing) {
            var source = SimpleCypher.decode(listing.id).source;
            return source !== 'firstam' || (source === 'firstam' && !!listing.hero);
        });
    }
};

module.exports = listingFilters;
